import React, { PureComponent } from 'react';
import { Select } from 'antd';
import Big from 'big.js';
import classNames from 'classnames';
import { isArray } from 'lodash-es';

import { BaseInputProps } from '../types';
import { isNullLike } from '../utils';

import { Num } from './Num';

export interface HardLimitHandlerInfo {
  name: string;
  protectThreshold?: number;
  wideningScaler?: number;
}

export interface HardLimitHandlerProps extends BaseInputProps {
  value?: HardLimitHandlerInfo;

  onChange?: (val: HardLimitHandlerInfo) => void;

  options?: string[];
}

export class HardLimitHandler extends PureComponent<HardLimitHandlerProps> {
  value: HardLimitHandlerInfo[] = [];

  isEmptyItem = (item: HardLimitHandlerInfo) => {
    return (
      !item.name?.trim() &&
      isNullLike(item.protectThreshold) &&
      isNullLike(item.wideningScaler)
    );
  };

  onChange = (
    key: 'name' | 'protectThreshold' | 'wideningScaler',
    val?: string[] | number,
  ) => {
    const value = { ...this.props.value } as any;
    value[key] = isArray(val) ? val[0] : val;
    this.props.onChange?.(value);
  };

  render() {
    return (
      <div
        className={classNames(
          this.props.className
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          <span>
            {this.props.value?.name}
            <span>/</span>
            {!isNullLike(this.props.value?.protectThreshold)
              ? `${+Big(Number(this.props.value?.protectThreshold)).times(
                  100,
                )}%`
              : '-'}
            <span>/</span>
            {!isNullLike(this.props.value?.wideningScaler)
              ? `${+Big(Number(this.props.value?.wideningScaler)).times(100)}%`
              : '-'}
          </span>
        ) : (
          <div className="grid grid-cols-3 gap-4 w-full">
            <div className="font-medium text-gray-700 rounded-md">
              <span>Protection Mode</span>
            </div>
            <div className="font-medium text-gray-700 rounded-md">
              ProtectThreshold(%)
            </div>
            <div className="font-medium text-gray-700 rounded-md">WideningScaler(%)</div>
            <Select
              value={[this.props.value?.name || '']}
              onChange={val => this.onChange('name', val)}
              options={[
                'OneWayQuote',
                'OneWayWider',
                'TwoWayWider',
                'Nothing',
              ].map(it => ({ label: it, value: it }))}
            />
            <Num
              value={this.props.value?.protectThreshold}
              onChange={val => this.onChange('protectThreshold', val)}
              inputWidth={100}
              isPercentage
            />
            <Num
              value={this.props.value?.wideningScaler}
              onChange={val => this.onChange('wideningScaler', val)}
              inputWidth={100}
              isPercentage
            />
          </div>
          // <div className="grid grid-cols-3 gap-4 w-full">
          //   <div className="font-medium text-gray-700 rounded-md">Protection Mode</div>
          //   <div className="font-medium text-gray-700 rounded-md">ProtectThreshold(%)</div>
          //   <div className="font-medium text-gray-700 rounded-md">WideningScaler(%)</div>
            
          //   <div className="flex items-center">
          //     <Select
          //       className="w-full max-w-[16rem] rounded-md"
          //     />
          //   </div>
            
          //   <div className="flex items-center">
          //     <Num
          //       className="w-full max-w-[6.25rem] rounded-md"
          //     />
          //   </div>
            
          //   <div className="flex items-center">
          //     <Num
          //       className="w-full max-w-[6.25rem] rounded-md"
          //     />
          //   </div>
          // </div>
        )}
      </div>
    );
  }
}
